<template>
  <div>
    <v-layout row wrap v-if="users && users.length">
      <v-flex xs6 mt-2 v-for="user in users" :key="user.id">
        <v-card class="text-xs-center mx-1" max-width="auto">
          <v-avatar size="90px" class="mt-4">
            <v-img
              :src="user.image"
              aspect-ratio="1.9"
              @click="show_user(user)"
              class="hover ma-0 pa-0"
              :style="`border: 3.2px solid ${user.color}; background-color: ${user.color}`"
            ></v-img>
          </v-avatar>
          <v-layout row wrap>
            <v-flex xs12 style="height: 50px;">
              <v-flex xs12
                class="text-xs-center font-weight-bold text-uppercase text-12-security pt-1"
              >{{ user.name }}</v-flex>
              <v-flex xs12
                class="text-xs-center font-weight-bold text-uppercase text-12-security"
              >{{ user.last_name }}</v-flex>
            </v-flex>
            <v-flex
              xs12
              class="center pb-1 text-14-security"
              style="line-height: 10px;"
            >{{ user.company }}</v-flex>
            <v-flex xs12 mb-2>
              <v-btn
                flat
                small
                v-bind:href="`mailto:${user.email}`"
                :color="user.color"
                dark
                class="font-weight-bold"
                style="text-transform: none"
              >
                <i class="material-icons">
                  <img v-if="user.color == '#8D0C9A'" class="material-icons p-auto color-purple" style="width: 15px; padding-bottom: 4px;" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/cake-variant.svg" alt="">
                  <img v-if="user.color == '#008DCF'" class="material-icons p-auto color-lightblue " style="width: 15px; padding-bottom: 4px;" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/cake-variant.svg" alt="">
                  <img v-if="user.color == '#FF052B'" class="material-icons p-auto color-red " style="width: 15px; padding-bottom: 4px;" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/cake-variant.svg" alt="">
                  <img v-if="user.color == '#FF6E00'" class="material-icons p-auto color-orange " style="width: 15px; padding-bottom: 4px;" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/cake-variant.svg" alt="">
                  <img v-if="user.color == '#628D36'" class="material-icons p-auto color-green " style="width: 15px; padding-bottom: 4px;" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/cake-variant.svg" alt="">
                  <img v-if="user.color == '#bbb'" class="material-icons p-auto color-default " style="width: 15px; padding-bottom: 4px;" src="https://assets-intranet-security.s3.us-east-2.amazonaws.com/cake-variant.svg" alt="">
                </i>
                <span class="pt-1 pl-1 caption font-weight-bold">Felicitar</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout v-else row wrap>
      <v-flex sm12 :style="paddingTop">
        <v-card flat>
          <v-card-text>
            <v-layout align-center justify-center row wrap fill-height>
              <v-flex
                class="text-29-security text-xs-center font-weight-bold"
                style="color: #525252"
              >No hay cumpleaños este mes</v-flex>
              <v-flex class="text-md-center">
                <router-link
                  class="text-14-security text-xs-center font-weight-bold green-security no-underline"
                  to="celebremos-cumpleanos"
                >Ver todos</router-link>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<style scoped>
.user_birthday .v-image__image {
  background-position: center top !important;
}
.greeting {
  font-family: Lato, sans-serif;
  line-height: 12px;
  font-size: 12px;
}
.greeting a {
  text-decoration: none;
  color: black;
}
.link-format a {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  font-family: Lato, sans-serif;
  padding-left: 12px;
}
.link-format:hover {
  text-decoration: underline;
}
.color-purple{
  filter: invert(9%) sepia(94%) saturate(7242%) hue-rotate(294deg) brightness(79%) contrast(112%);
}
.color-lightblue {
  filter: invert(44%) sepia(64%) saturate(6283%) hue-rotate(178deg) brightness(100%) contrast(101%);
}
.color-red {
  filter: invert(13%) sepia(90%) saturate(7315%) hue-rotate(345deg) brightness(104%) contrast(116%);
}
.color-orange {
  filter: invert(41%) sepia(64%) saturate(1560%) hue-rotate(1deg) brightness(104%) contrast(104%);
}
.color-green {
  filter: invert(44%) sepia(59%) saturate(409%) hue-rotate(47deg) brightness(99%) contrast(92%);
}
.color-gris {
  filter: invert(82%) sepia(14%) saturate(0%) hue-rotate(144deg) brightness(89%) contrast(93%);
}
.color-default {
  filter: invert(81%) sepia(10%) saturate(25%) hue-rotate(345deg) brightness(94%) contrast(84%);
}
</style>

<script>
import config from "@/config";
import axios from "axios";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      users: []
    };
  },
  beforeMount() {
  },
  async mounted() {
    const { data: homeBirthdays } = await axios.get(
      process.env.VUE_APP_API_URL + "/birthdays/get_home_birthdays"
    );

    this.users = homeBirthdays

    if (this.$vuetify.breakpoint.smAndDown) {
      this.users = this.users.slice(0, 2)
    }
  },
  computed: {
    paddingTop() {
      return this.$vuetify.breakpoint.smAndDown ? 'padding-top: 15%' : 'padding-top: 35%'
    }
  },
  methods: {
    ...mapActions("user", ["fetchUser"]),
    show_user(user) {
      this.fetchUser(user.id);
      this.$router.push({
        name: "user-show",
        params: { id: user.id }
      });
    },
  }
};
</script>
